module.exports = __webpack_public_path__ + "static/media/background.730b2e4b.svg";